<template>
  <div class="card" :class="cardBgClass">
    <div class="p-3 card-body">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex  align-items-center ">
          <h4 class="mb-0 mx-1" :class="{
            'text-danger font-weight-bold': orders.statuses?.some(s => s !== 'COMPLETE')
          }"> <b>{{ symbol }} - {{ term }}</b>
          </h4>
          <span :class="badgeConfig.class">{{ badgeConfig.text }}</span>
          <div v-if="exitDetails && exitDetails.length > 0" class="position-relative px-2 ms-2">
            <i @click="this.modals.classic = true;" class="fas fa-info-circle text-warning"></i>
          </div>
        </div>
        <div class="my-auto ms-1 position-relative" @mouseenter="showTooltip = true" @mouseleave="showTooltip = false">
          <div v-if="showTooltip"
            class="position-tooltip-content position-tooltip-left position-absolute bg-white border rounded p-2 shadow ">
            <div v-for="(item, index) in orders.portfolios" :key="index"
              :class="{ 'text-dark font-weight-bold': item.status === 'OPEN' }">
              {{ formatPortfolioName(item.name) }}
            </div>
          </div>
          <span class="badge bg-white rounded-pill text-primary text-sm px-2 py-2">
            {{ orders.portfolios?.length }}
          </span>
        </div>
      </div>
      <hr class="horizontal dark my-1" />
      <div class="row">
        <div class="col-6 col-sm-3 text-center ">
          <div class="col-12 justify-content-center d-flex">
            <h6 class="mb-0 text-sm" :class="{ 'text-danger font-weight-bold': quantity !== brokerQuantity }">{{
              quantity }}/{{ brokerQuantity }}</h6>
          </div>
          <p class="mb-0 text-sm text-primary font-weight-bold">
            Quantity
          </p>
        </div>
        <div class="col-6 col-sm-3 text-center ">
          <div class="col-12 justify-content-center d-flex">
            <h6 class="mb-0 text-sm">₹ {{ avgPrice.toFixed(2) }}</h6>
          </div>
          <p class="mb-0 text-sm text-primary font-weight-bold">
            Avg Price
          </p>
        </div>
        <div class="col-6 col-sm-3 mt-3 mt-sm-0 text-center">
          <div class="col-12 justify-content-center d-flex">
            <h6 class="mb-0 text-sm text-primary">₹ {{ ltp.toFixed(2) }}</h6>
          </div>
          <p class="mb-0 text-sm text-primary font-weight-bold">
            LTP
          </p>
        </div>
        <div class="col-6 col-sm-3 mt-3 mt-sm-0 text-center">
          <div class="col-12 justify-content-center d-flex">
            <h6 class="mb-0 text-sm" :class="[pl > 0 ? 'text-green' : pl == 0 ? 'text-dark' : 'text-danger']">₹ {{
              pl.toFixed(2) }}
            </h6>
          </div>
          <p class="mb-0 text-sm text-primary font-weight-bold">P&L</p>
        </div>
      </div>
    </div>
  </div>
  <ShowExitDetailModal :showModal="modals.classic" :exitDetails="exitDetails" @updateParameters=handleModalClose>
  </ShowExitDetailModal>
</template>
<script>
import ShowExitDetailModal from "./ShowExitDetailModal.vue";
export default {
  name: "TradeCard",
  components: {
    ShowExitDetailModal
  },
  props: {
    symbol: {
      type: String,
      default: "",
    },
    term: {
      type: String,
      default: "",
    },
    time: {
      type: String,
      default: "",
    },
    quantity: {
      type: Number,
      default: 0.0,
    },
    userName: {
      type: String,
      default: "",
    },
    avgPrice: {
      type: Number,
      default: 0.0,
    },
    ltp: {
      type: Number,
      default: 0.0,
    },
    pl: {
      type: Number,
      default: 0.0,
    },
    orders: {
      type: Object,
      default: () => ({})
    },
    exitDetails: {
      type: Array,
      default: () => []
    },
    brokerQuantity: {
      type: Number,
      default: 0.0,
    },
  },
  data() {
    return {
      showTooltip: false,
      showModal: false,
      modals: {
        classic: false,
      },
    }
  },
  computed: {
    cardBgClass() {
      const hasOpen = this.orders.portfolios?.some(p => p.status === 'OPEN');
      return hasOpen ? 'bg-portfolio-pnl' : 'bg-position-closed';
    },
    badgeConfig() {
      const hasOpen = this.orders.portfolios?.some(p => p.status === 'OPEN');
      if (!hasOpen) {
        return { text: 'CLOSED', class: 'badge badge-sm mx-1 bg-gray text-white' };
      }
      if (this.quantity > 0) {
        return { text: 'BUY', class: 'badge badge-sm mx-1 bg-green text-white' };
      }
      if (this.quantity < 0) {
        return { text: 'SHORT', class: 'badge badge-sm mx-1 bg-danger text-white' };
      }

      return { text: 'CLOSED', class: 'badge badge-sm mx-1 bg-gray text-white' };
    },
  },
  methods: {
    emitPopup(tradeInstrument) {
      this.$emit('on-exit', tradeInstrument);
    },
    handleModalClose(showModal) {
      this.modals.classic = showModal;
    },
    formatPortfolioName(name) {
      return name
        .split('_')
        .map(word => {
          return /^[a-zA-Z]+$/.test(word)
            ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            : word;
        })
        .join(' ');
    }
  },
};
</script>
